module.exports = __webpack_public_path__ + "static/media/intro.1b14b7c6.mp3";